import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface ChatNotificationState {
  /** Firestore 파생 — consoleInbox.adminUnread === true 인 채널 수 (안읽은 채널 수) */
  unreadCount: number;
}

const initialState: ChatNotificationState = {
  unreadCount: 0,
};

const chatNotificationsSlice = createSlice({
  name: 'chatNotifications',
  initialState,
  reducers: {
    /** 전역 받은편지함 리스너가 안읽은 채널 수를 동기화한다. */
    setInboxUnreadCount: (state, action: PayloadAction<number>) => {
      state.unreadCount = action.payload;
    },
    resetChatNotifications: () => initialState,
  },
});

export const selectChatUnreadCount = (state: { chatNotifications: ChatNotificationState }) =>
  state.chatNotifications.unreadCount;

export const { setInboxUnreadCount, resetChatNotifications } = chatNotificationsSlice.actions;

export default chatNotificationsSlice.reducer;
